import { render, staticRenderFns } from "./HorizontalNavMenuHeader.vue?vue&type=template&id=54523ac7"
import script from "./HorizontalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuHeader.vue?vue&type=style&index=0&id=54523ac7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports